import { connect } from 'react-redux'
import cardPickerSelector from './cardPickerSelector'
import CardPicker from './CardPicker'
import { withBoardContext } from 'dataProviders/Board'

export default withBoardContext(connect(
  cardPickerSelector,
  {}
)(CardPicker))
